import { Grid, Typography } from "@material-ui/core";
import { useQuery } from "@redux-requests/react";
import _, { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { CardItem, Loader, NoSessionData } from "../../components";
import { types } from "../../ducks";
import { getSpeakerSessions } from "../../ducks/actions";

const SessionsTab = ({ profileId }) => {
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSpeakerSessions({ profileId }));
  }, [dispatch, profileId]);
  const {
    data: { data: speakerSessions },
    speakerSessionsLoading
  } = useQuery({ type: types.GET_SPEAKER_SESSIONS, defaultData: { data: [] } });

  const futureSpeakerSessions = _.sortBy(speakerSessions, [
    "programEvent.startAt"
  ]).filter(({ programEvent }) => moment(programEvent.startAt).isAfter());

  const pastSpeakerSessions = _.sortBy(speakerSessions, ["programEvent.startAt"])
    .filter(({ programEvent }) => !moment(programEvent.startAt).isAfter())
    .map(({ recordings, ...s }) => ({
      ...s,
      videoUrl: !isEmpty(recordings) && recordings[0].videoUrl
    }));

  return (
    <>
      <Typography variant="h5">
        {intl.formatMessage({
          id: "Experts.SessionsTab.UpcomingSessions",
          defaultMessage: "Upcoming Sessions"
        })}
      </Typography>
      <Loader loading={speakerSessionsLoading}>
        <NoSessionData data={futureSpeakerSessions}>
          <Grid container spacing={3}>
            {futureSpeakerSessions.map(({ id, title, thumbUrl, programEvent }) => (
              <Grid key={id} item xs={12} sm={3}>
                <CardItem
                  title={title}
                  programEvent={programEvent}
                  thumbUrl={thumbUrl}
                  onClick={() => {
                    history.push(`/sessions/${id}`);
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </NoSessionData>
      </Loader>

      <Typography variant="h5">
        {intl.formatMessage({
          id: "Exhibitors.SessionsTab.Sessions",
          defaultMessage: "Sessions"
        })}
      </Typography>
      <Loader loading={speakerSessionsLoading}>
        <NoSessionData data={pastSpeakerSessions}>
          <Grid container spacing={3}>
            {pastSpeakerSessions.map(({ id, title, thumbUrl }) => (
              <Grid key={id} item xs={12} sm={3}>
                <CardItem
                  title={title}
                  thumbUrl={thumbUrl}
                  duration={`${0}:${0}`}
                  onClick={() => {
                    history.push(`/sessions/${id}`);
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </NoSessionData>
      </Loader>
    </>
  );
};

export default SessionsTab;
